export const base_filter = [];

export const base_table = {
	page: 1,
	per_page: 20,
	order_by: "name",
	order_dir: "asc",
};

export const base_object = {
	id: null,
	name: "",
	description: "",
	estate_parent_ids: [],
	members: [],
	is_active: true,
	notification_type: [],
};

export const base_member = {
	id: null,
	name: "",
	email: "",
	phone: "",
};
